import * as React from "react";
import Button from "@mui/material/Button";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import Stack from "@mui/material/Stack";
import { Badge } from "@mui/material";
import NotificationImportantIcon from "@mui/icons-material/NotificationImportant";
import { useHistory } from "react-router-dom";

export const Notification = ({ notifications }) => {
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const history = useHistory();

  const viewedNotifications = JSON.parse(
    sessionStorage.getItem("hideNotifications") ?? "[]"
  );
  const showCounter =
    viewedNotifications
      .map((item) => item.quantity)
      .reduce((a, b) => a + b, 0) !==
    notifications.map((item) => item.quantity).reduce((a, b) => a + b, 0);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const redirectTicktListByInterference = (item) => {
    sessionStorage.setItem(
      "hideNotifications",
      JSON.stringify([{ type: item.type, quantity: item.quantity }])
    );
    history.push(item.url, { type: item.type });
    setOpen(false);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    } else if (event.key === "Escape") {
      setOpen(false);
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  return (
    <Stack direction="row" spacing={1} style={{ marginTop: "8px" }}>
      <div>
        <Button
          ref={anchorRef}
          id="composition-button"
          aria-controls={open ? "composition-menu" : undefined}
          aria-expanded={open ? "true" : undefined}
          aria-haspopup="true"
          onClick={handleToggle}
        >
          <Badge badgeContent={!showCounter ? 0 : notifications.map((item) => item.quantity).reduce((a, b) => a + b, 0)} color="error">
            <NotificationImportantIcon
              color="white"
              style={{ color: "white" }}
            />
          </Badge>
        </Button>
        <Popper
          open={open}
          anchorEl={anchorRef.current}
          role={undefined}
          placement="bottom-start"
          transition
          disablePortal
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin:
                  placement === "bottom-start" ? "left top" : "left bottom",
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList
                    autoFocusItem={open}
                    id="composition-menu"
                    aria-labelledby="composition-button"
                    onKeyDown={handleListKeyDown}
                  >
                    {notifications.map((item) => {
                      return (
                        <MenuItem onClick={()=>redirectTicktListByInterference(item)}>
                          {item.name} ({item.quantity})
                        </MenuItem>
                      );
                    })}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>
    </Stack>
  );
};
